export type AskResponse = {
    answer: string;
    error?: string;
    message_id?: string;
    prompt_tokens?: number;
    completion_tokens?: number;
    final_tokens?: number;
};

export type Citation = {
    content: string;
    id: string;
    title: string | null;
    filepath: string | null;
    url: string | null;
    metadata: string | null;
    chunk_id: string | null;
    reindex_id: string | null;
};

export type ChatMessage = {
    id: string;
    role: string;
    content: string;
    end_turn?: boolean;
    date: string;
    context?: string;
    prompt_tokens?: number;
    completion_tokens?: number;
    final_tokens?: number;
};

export type Conversation = {
    id: string;
    title: string;
    messages?: ChatMessage[];
    date: string;
    model_settings?: GptModelSettings | null;
    scenario_id?: string | null;
    num_historic_messages: number;
    folder_id?: string | null;
};

export enum ChatCompletionType {
    ChatCompletion = "chat.completion",
    ChatCompletionChunk = "chat.completion.chunk",
}

export type ChatResponse = {
    id: number;
    type: string;
    data: ChatResponseContent | ChatErrorContent | HistoryMetadata;
};

export type ChatErrorContent = {
    error: string;
};

export type HistoryMetadata = {
    conversation_id: string;
    title: string;
    date: string;
    scenario_id?: string | null;
    llm_settings?: GptModelSettings | null;
};

export type ChatResponseContent = {
    id: string;
    model: string;
    created: number;
    object: ChatCompletionType;
    delta?: string;
    role: string;
    error?: any;
    completion_tokens?: number;
    prompt_tokens?: number;
    final_tokens?: number;
};

export type ConversationRequest = {
    messages: ChatMessage[];
    model_settings: GptModelSettings | undefined;
    instruction?: string;
    scenario?: Scenario | null;
    num_historic_messages: number;
    folder_id?: string | null;
    file_ids: string[];
};

export type ConversationRequestWithoutMessages = {
    model_settings: GptModelSettings | undefined;
    instruction?: string;
    scenario?: Scenario | null;
    num_historic_messages: number;
    title?: string;
};

export type UserInfo = {
    access_token: string;
    expires_on: string;
    id_token: string;
    provider_name: string;
    user_claims: any[];
    user_id: string;
};

export enum CosmosDBStatus {
    NotConfigured = "CosmosDB is not configured",
    NotWorking = "CosmosDB is not working",
    InvalidCredentials = "CosmosDB has invalid credentials",
    InvalidDatabase = "Invalid CosmosDB database name",
    InvalidContainer = "Invalid CosmosDB container name",
    Working = "CosmosDB is configured and working",
}

export type CosmosDBHealth = {
    cosmosDB: boolean;
    status: string;
};

export enum ChatHistoryLoadingState {
    Loading = "loading",
    Success = "success",
    Fail = "fail",
    NotStarted = "notStarted",
}

export type ErrorMessage = {
    subtitle?: string;
    message: string;
};

export type LanguageModelSettings = {
    top_p: number;
    temperature: number;
    presence_penalty: number;
    frequency_penalty: number;
    max_tokens: number;
};

export type GptModelSettings = {
    name: string;
    settings: LanguageModelSettings;
};

export type GlobalSettings = {
    instruction: string;
    showNumHistoricMessages: boolean;
};

export type Scenario = {
    name: string;
    persona: string;
    context: string;
    goal?: string;
    output_format?: string;
    further_instructions?: string;
    scenario_id: string;
    folder_id: string;
};

export type VectorFileRequest = {
    file: File;
    conversationId: string;
};

export type VectorFile = {
    id: string;
    conversationId: string;
    fileName: string;
    status: string;
    fileId: string;
};

export type ConversationFolder = {
    name: string;
    id: string;
    conversations?: Conversation[] | null;
};

export type ScenarioFolder = {
    name: string;
    id: string;
    scenarios?: Scenario[] | null;
};
